import { ActivityCategoryDto, ActivityTypeDto } from '@/api/ApiClient';

/** UI labels for {@link ActivityTypeDto} (matches server `Tools/Enums/ActivityType.cs`). */
export const ACTIVITY_TYPE_LABELS: Record<ActivityTypeDto, string> = {
  [ActivityTypeDto.Preparation]: 'Preparation',
  [ActivityTypeDto.Synthesis]: 'Synthesis',
  [ActivityTypeDto.PostTreatment]: 'PostTreatment',
  [ActivityTypeDto.Dicing]: 'Split',
  [ActivityTypeDto.Grouping]: 'Grouping',
  [ActivityTypeDto.Publication]: 'Publication',
  [ActivityTypeDto.Presentation]: 'Presentation',
  [ActivityTypeDto.Proposal]: 'Proposal',
  [ActivityTypeDto.Award]: 'Project awarded',
  [ActivityTypeDto.Decision]: 'Decision',
  [ActivityTypeDto.Document]: 'Document',
  [ActivityTypeDto.Report]: 'Report',
};

/** Processing activity types shown in Add Processing and recipe flows. */
export const PROCESSING_ACTIVITY_TYPE_OPTIONS: ActivityTypeDto[] = [
  ActivityTypeDto.Preparation,
  ActivityTypeDto.Synthesis,
  ActivityTypeDto.PostTreatment,
];

export type ProjectActivityType =
  | ActivityTypeDto.Publication
  | ActivityTypeDto.Presentation
  | ActivityTypeDto.Proposal
  | ActivityTypeDto.Award
  | ActivityTypeDto.Document
  | ActivityTypeDto.Decision
  | ActivityTypeDto.Report;

/** UI labels for {@link ActivityCategoryDto} (matches server `Tools/Enums/ActivityCategory.cs`). */
export const ACTIVITY_CATEGORY_LABELS: Record<ActivityCategoryDto, string> = {
  [ActivityCategoryDto.Project]: 'Project',
  [ActivityCategoryDto.Theory]: 'Theory',
  [ActivityCategoryDto.Trash]: 'Trash',
  [ActivityCategoryDto.Transfer]: 'Transfer',
  [ActivityCategoryDto.Storage]: 'Storage',
  [ActivityCategoryDto.Processing]: 'Processing',
  [ActivityCategoryDto.Characterization]: 'Characterization',
  [ActivityCategoryDto.Inventory]: 'Inventory',
};

export function isActivityTypeDto(value: unknown): value is ActivityTypeDto {
  return typeof value === 'string' && value in ACTIVITY_TYPE_LABELS;
}

export function isActivityCategoryDto(value: unknown): value is ActivityCategoryDto {
  return typeof value === 'string' && value in ACTIVITY_CATEGORY_LABELS;
}

/** Display label for an activity type code from the API. */
export function getActivityTypeDisplay(type: ActivityTypeDto | string | null | undefined): string {
  if (!type) {
    return '';
  }
  if (isActivityTypeDto(type)) {
    return ACTIVITY_TYPE_LABELS[type];
  }
  return type;
}

/** Display label for an activity category code from the API. */
export function getActivityCategoryDisplay(category: ActivityCategoryDto | string | null | undefined): string {
  if (!category) {
    return '';
  }
  if (isActivityCategoryDto(category)) {
    return ACTIVITY_CATEGORY_LABELS[category];
  }
  return category;
}

/** Value/label pairs for MUI Select and FormSelect. */
export function activityTypeSelectOptions(types: ActivityTypeDto[]): { value: ActivityTypeDto; label: string }[] {
  return types.map((value) => ({
    value,
    label: ACTIVITY_TYPE_LABELS[value],
  }));
}
